import { render, staticRenderFns } from "./TopicsRootView.vue?vue&type=template&id=fd9645f6"
import script from "./TopicsRootView.vue?vue&type=script&lang=js"
export * from "./TopicsRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports